<template>
  <section>
    <div
      id="myChart"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
const colorList = ["#4992FF", "#58D9F9", "#7CFFB2"];

import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
      dataValue: [],
      yName: [],
      mountData: "",
      updateData: "",
      fullDiv: {
        left: "5%",
        right: "5%",
        bottom: "5%",
        top: "10%",
        containLabel: true,
      },
    };
  },
  props: {
    boxHeight: {
      default: 21,
      type: Number,
    },
    showtime: {
      default: false,
      type: Boolean,
    },
    showLegend: {
      default: false,
      type: Boolean,
    },
    coordinateName: {
      default: "",
      type: String,
    },
    graphicalRightData: {
      //是否显示图形右边的文字
      default: false,
      type: Boolean,
    },
  },

  components: {},

  mounted() {
    let that = this;
    if (window.outerWidth <= 1920) {
      this.fullDiv = {
        left: "5%",
        right: "5%",
        bottom: "1%",
        top: "10%",
        containLabel: true,
      };
    }
    window.onresize = function () {
      that.myChart.resize();
    };
    // this.bus.$on("updatechartData", (content) => {
    //   this.dataValue = content;
    //   if (this.myChart) {
    //     this.myChart.setOption({
    //       series: [{ data: content.data }],
    //       yAxis: {
    //         data: content.yName,
    //       },
    //     });
    //   }
    // });
    // this.bus.$on("initchartData", (content) => {
    //   this.mountData = content;
    //   this.myEcharts();
    // });
    // this.myEcharts();
  },
  watch: {},
  methods: {
    upDateChart(content) {
      console.log("content", content);
      this.myChart.setOption({
        series: [
          {
            data: content.seriseList,
          },
        ],
      });
    },
    myEcharts(data, allData, year) {
      let echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myChart);
      this.setChartData(data, allData, year);
      // 指定图表的配置项和数据
    },
    setChartData(_data, allData, year) {
      // console.log("data", _data);
      let option = {
        xAxis: {
          name: "",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          data: _data.xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: _data.axisLabel
            ? _data.axisLabel
            : {
                formatter: function (value) {
                  //x轴的文字改为竖版显示
                  let str = value.split("");
                  return str.join("\n");
                },
                fontSize: this.$common.setFontSize(0.69),
              },
        },
        yAxis: [
          {
            splitLine: {
              //网格线
              show: true,
              lineStyle: {
                color: "rgba(204, 204, 204, 0.2)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} %",
              fontSize: this.$common.setFontSize(0.69),
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 30,
            height: "80%",
            showDataShadow: false,
            left: "93%",
          },
        ],
        series: [
          {
            // name: "X",
            type: "bar",
            barWidth: _data.barWidth ? _data.barWidth : 5,
            data: _data.seriseList, //dataArr,
            // itemStyle: {
            //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     { offset: 0, color: "#83bff6" },
            //     { offset: 0.5, color: "#188df0" },
            //     { offset: 1, color: "#188df0" },
            //   ]),
            // },
            itemStyle: {
              color: function (param) {
                if (param.value > 0) {
                  return "#FDDD60";
                } else {
                  return "#4992FF";
                }
              },
            },
            label: _data.label
              ? _data.label
              : {
                  show: false,
                  position: "top",
                  valueAnimation: true,
                  color: "#FFFFFF",
                  formatter: (() => {
                    return "{`123`}{b}: {@score}";
                  })(),
                },
          },
        ],
        legend: {
          show: this.showLegend,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(0,0,0,0.3)",
          borderWidth: "0",
          textStyle: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.9),
          },
          formatter: _data.formatter
            ? _data.formatter
            : function (params) {
                // console.log('params',params,allData,year);
                let contentData = params[0];
                let rateStr = "";
                if (contentData.data > 0) {
                  rateStr = `增长${contentData.data}%`;
                } else {
                  rateStr = `减少${contentData.data.toString().substring(1)}%`;
                }
                return `${contentData.name}${year[0]}年至${
                  year[1]
                }年变化值为 <span style="font-weight:bold">${Number(
                  allData.changeList[contentData.dataIndex] / 10000
                ).toFixed(2)}</span> 万吨,${rateStr}`;
              },
        },
        grid: this.fullDiv,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
  destroyed() {
    // this.bus.$off("updateData");
  },
};
</script>
<style lang='scss' scoped>
</style>